module.exports = __webpack_public_path__ + "images/environment-c20de8ee46062155f9e39718db7e03d5.jpg";